import { AxiosService } from '../../../utils/AxiosService';
import Config from '../../../config';

const getAssignedAdvisorUserBiometricInfos = async userId => await AxiosService.get(Config.server.api.biometricMatrixApi + `advisor/user/${userId}`, true);

export default {
    getAssignedAdvisorUserBiometricInfos
}